module.exports = __webpack_public_path__ + "static/media/estimate.64533b2b.svg";